import React, { useState, useEffect } from "react";
import Dropdown from "./Dropdown";
import TableTeam from "./TableTeam";
import { loadStyles } from "../../../utils/cssLoader";

const TeamTableWrp = ({
  data,
  teamId,
  baseUrl,
  dataClient,
  loadCSS,
  title,
}) => {
  const [clientData, setClientData] = useState([]);
  const [teamData, setTeamData] = useState(dataClient ? clientData : data?.standings);
  const [leagueSelectedId, setLeagueSelectedId] = useState(teamId);
  // Load client-side data (from data-listingdata attribute)

  useEffect(() => {
    if (!dataClient) return;

    const container = document.querySelector(".microservice-cont");
    const raw = container?.getAttribute("data-listingdata");
    if (!raw) return;

    try {
      const parsed = JSON.parse(raw)?.data;
      setClientData(parsed);
      setTeamData(parsed?.standings);
      setLeagueSelectedId(parsed?.league?.data?.[0]?.id || null);
    } catch (error) {
      console.error("Failed to parse client data:", error);
    }
  }, [dataClient]);

  // Fallback to SSR-provided props if not using dataClient
  useEffect(() => {
    if (!dataClient && data) {
      setTeamData(data?.standings);
      setLeagueSelectedId(data?.league?.data?.[0]?.id || null);
      setClientData(data);
    }
  }, [dataClient, data]);

  // Dynamic CSS injection
  useEffect(() => {
    if (loadCSS === "true") {
      loadStyles("team");
    }
  }, [loadCSS]);

  // Fetch updated team table when league selection changes
  useEffect(() => {
    if (!leagueSelectedId || !teamId) return;

    const fetchTableData = async () => {
      try {
        const res = await fetch(
          `${baseUrl}/football/team/${teamId}/table?leagueId=${leagueSelectedId}`,
          {
            headers: {
              Token: process.env.REACT_APP_API_TOKEN,
            },
          }
        );
        if (!res.ok) throw new Error(res.statusText);

        const json = await res.json();
        setTeamData(json);
      } catch (err) {
        console.error("Failed to fetch team table:", err);
      }
    };

    fetchTableData();
  }, [leagueSelectedId, teamId, baseUrl]);

  const items = clientData?.league || data?.league;

  return (
    <>
      {title && <h1>{title}</h1>}

      {items?.data?.length > 0 && (
        <Dropdown
          items={items.data}
          defaultValue={leagueSelectedId}
          setLeagueSelectedId={setLeagueSelectedId}
        />
      )}

      <TableTeam teamTable={teamData?.data || []} />
    </>
  );
};

export default TeamTableWrp;
